import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

export const Textarea = forwardRef(function Textarea(
  { className, label, error, hint, required, rows = 3, id, ...props },
  ref,
) {
  const inputId = id || props.name
  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label
          htmlFor={inputId}
          className="mb-1.5 block text-sm font-semibold text-ink-800"
        >
          {label}
          {required && <span className="ml-0.5 text-accent-600">*</span>}
        </label>
      )}
      <textarea
        id={inputId}
        ref={ref}
        rows={rows}
        className={cn(
          'block w-full rounded-xl bg-white px-3.5 py-3 text-sm text-ink-900 placeholder:text-ink-400',
          'ring-1 ring-inset transition-all duration-150 resize-y',
          'focus:outline-none focus:ring-2 focus:ring-primary-500',
          error
            ? 'ring-rose-400 focus:ring-rose-500'
            : 'ring-ink-200 hover:ring-ink-300',
        )}
        {...props}
      />
      {error ? (
        <p className="mt-1.5 text-xs font-medium text-rose-600">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-ink-500">{hint}</p>
      ) : null}
    </div>
  )
})
